var _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFl80(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.23 11.31 7.23 8.55 0 15 7.23 21.45 7.23 18.69 12.89 18.69 12.89 11.31 7.23 11.31"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "22.77 11.31 22.77 8.55 30 15 22.77 21.45 22.77 18.69 17.11 18.69 17.11 11.31 22.77 11.31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFl80);
export default __webpack_public_path__ + "static/media/FL80.2174e017bae5f6ab189bea51021772d0.svg";
export { ForwardRef as ReactComponent };